'use client';

import SelectControl, {
  Props as BaseSelectControlProps,
} from '@/components/Controls/SelectControl';

import { useDemoContext } from './DemoContext';

type SliderControlProps = Omit<
  BaseSelectControlProps,
  'value' | 'setValue'
>;

function DemoSelectControl({ id, ...props }: SliderControlProps) {
  const context = useDemoContext();

  const { id: demoUnitId, state, setState } = context;
  const value = state[id];
  const htmlId = `${demoUnitId}_${id}`;

  return (
    <SelectControl
      {...props}
      id={htmlId}
      value={value}
      setValue={(newValue: any) => {
        setState((state) => ({
          ...state,
          [id]: newValue,
        }));
      }}
    />
  );
}

export default DemoSelectControl;
